const state = {
  defaultLang: null,
  languagesList: []
}

const getters = {
  defaultLang: state => state.defaultLang,
  languagesList: state => state.languagesList
}

const mutations = {
  SET_DEFAULT_LANG (state, lang) {
    state.defaultLang = lang

    state.languagesList = state.languagesList.map(l => {
      l.default = l.code === lang.code
      return l
    }).sort((a, b) => (a.default === b.default) ? 0 : a.default ? -1 : 1)
  },

  SET_LANGUAGES_LIST (state, languages) {
    state.languagesList = languages
  }
}

const actions = {
  setDefaultLang ({ state, commit }, code) {
    const lang = state.languagesList.find(e => e.code === code)
    if (!lang) {
      commit('SET_DEFAULT_LANG', {
        name: 'English',
        code: 'en'
      })
      return
    }
    commit('SET_DEFAULT_LANG', lang)
  },

  setLanguagesList ({ state, commit }, languages) {
    commit('SET_LANGUAGES_LIST', languages.map(l => {
      l.default = state.defaultLang ? state.defaultLang.code === l.code : false
      return l
    }))
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
